import { render } from "./GaleryImageSvg.vue?vue&type=template&id=2d0612ac"
import script from "./GaleryImageSvg.vue?vue&type=script&lang=js"
export * from "./GaleryImageSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__